/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginComplaintQueryResponse
 */
export interface LoginComplaintQueryResponse {
    /**
     * 
     * @type {string}
     * @memberof LoginComplaintQueryResponse
     */
    complaintId?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginComplaintQueryResponse
     */
    jwt: string;
}

/**
 * Check if a given object implements the LoginComplaintQueryResponse interface.
 */
export function instanceOfLoginComplaintQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jwt" in value;

    return isInstance;
}

export function LoginComplaintQueryResponseFromJSON(json: any): LoginComplaintQueryResponse {
    return LoginComplaintQueryResponseFromJSONTyped(json, false);
}

export function LoginComplaintQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginComplaintQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'complaintId': !exists(json, 'complaintId') ? undefined : json['complaintId'],
        'jwt': json['jwt'],
    };
}

export function LoginComplaintQueryResponseToJSON(value?: LoginComplaintQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'complaintId': value.complaintId,
        'jwt': value.jwt,
    };
}

